import { appMatchesConnectRequest } from "./appMatchesConnectRequest";
import { domainSearchToken } from "./urlDomain";

// Credential URL patterns often exclude product pages, so usable searches can suggest a domain match when the strict match is empty.
export function matchAvailableApps<
  T extends { urlPattern: string; identifier: string; name: string },
>(
  candidates: T[],
  { search, targetUrl }: { search?: string | null; targetUrl?: string | null },
  options: { urlFallback: boolean } = { urlFallback: true }
): { matched: T[]; urlFallback: boolean } {
  const matched = candidates.filter(
    (app) =>
      !(search || targetUrl) ||
      appMatchesConnectRequest(app, { search, targetUrl })
  );
  if (matched.length > 0 || !targetUrl || !options.urlFallback)
    return { matched, urlFallback: false };

  const token = search || domainSearchToken(targetUrl);
  if (!token) return { matched, urlFallback: false };
  const fallback = candidates.filter((app) =>
    appMatchesConnectRequest(app, { search: token })
  );
  return { matched: fallback, urlFallback: fallback.length > 0 };
}
